import { initializeMapConsent, hasMapConsent, setMapConsent } from '../consent/ridewithgps.js'

export default function initRouteMaps() {
    initializeMapConsent()
    const maps = [...document.querySelectorAll('[data-route-map]')]
    if (!maps.length) return

    const render = () => maps.forEach(root => {
        const placeholder = root.querySelector('[data-map-placeholder]')
        const canvas = root.querySelector('[data-map-canvas]')
        const allowed = hasMapConsent()
        placeholder.hidden = allowed
        canvas.hidden = !allowed
        if (!allowed) {
            canvas.replaceChildren()
        } else if (!canvas.querySelector('iframe')) {
            const frame = document.createElement('iframe')
            frame.title = 'ridewithgps Maps'
            frame.style.cssText = 'width: 1px; min-width: 100%; height: 700px; border: none;'
            frame.scrolling = 'no'
            frame.src = root.dataset.mapUrl
            canvas.appendChild(frame)
        }
    })
    maps.forEach(root => {
        root.querySelector('[data-map-allow]').addEventListener('click', () => setMapConsent(true))
    })
    window.addEventListener('mtb:maps-consent-changed', render)
    // Also remove existing frames when permission expires during this visit.
    window.setInterval(render, 60000)
    render()
}
